export class AddFollowup {
  memberId: number;
  planDate: Date;
  actualDate: Date;
  activity: number;
  status: number;
  assigner: number;
  assignerComment: string;
  assignee: number;
  assigneeComment: string;
  createdBy: string;
  creationDate: Date;
}
